export const HTTP_UNATHENTICATED_STATUSES: Set<number> = new Set([401, 403]);
export const AUTH_HEARTBEAT_INTERVAL_IN_MSEC: number = 60_000;
